import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import { useStores } from '../../hooks/use-stores';
import Content from '../content/Content';

function PartnerContent() {
    const { partnerId } = useParams();
    const { partnerStore, store, brandingStore } = useStores();

    useEffect(() => {
        const id = Number(partnerId);
        partnerStore.setCurrentPartnerId(id);
        store.setPartnerPreviewPartnerId(id);
        brandingStore.loadPartnerTranslationOverrides(id);
        return () => store.setPartnerPreviewPartnerId(null);
    }, [partnerId, partnerStore, store, brandingStore]);

    return (
        <Content
            partnerId={Number(partnerId)}
            partnerOnly
            defaultLanguage="en"
        />
    );
}

export default observer(PartnerContent);
